import React, { useRef, useState, useEffect } from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { getRandomBio } from "./farmers";

// Fallback data used when API is unavailable
// const DEFAULT_FARMERS = [
//   {
//     id: 1,
//     name: "Farmer",
//     registrationNo: "-",
//     dob: "-",
//     bio: "",
//     image: "img/farmer1.jpg",
//     cows: [
//       {
//         id: 101,
//         name: "Cow",
//         breed: "-",
//         dob: "-",
//         img: "img/c1-min.png",
//       },
//     ],
//   },
// ];

const normalize = (value) =>
  value === null || value === undefined || value === "null" || value === ""
    ? "None"
    : String(value);

const MeetTheFarmers = () => {
  const { farmersData, loading, errors } = useTraceabilityData();
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const moreFarmersScrollRef = useRef(null);
  const [showLoader, setShowLoader] = useState(true);

  // Extract data from context
  const farmersFromApi = farmersData?.mappedFarmers || [];
  const collectionDescription =
    farmersData?.description ||
    "Our farmers are the backbone of everything we do, bringing generations of expertise and care to every step of the process. They work tirelessly to ensure that the highest standards are met, from nurturing their livestock to embracing sustainable farming methods.";
  const isLoading = loading.farmers;
  const loadError = errors.farmers || "";

  // const displayedFarmers = farmersFromApi;
  const displayedFarmers = (farmersFromApi || []).slice(0, 10);

  const activeFarmer = displayedFarmers[currentSlideIndex];

  const goToNextSlide = () => {
    const length = displayedFarmers.length;
    if (length === 0) return;
    setCurrentSlideIndex((prev) => (prev + 1) % length);
  };

  const goToPreviousSlide = () => {
    const length = displayedFarmers.length;
    if (length === 0) return;
    setCurrentSlideIndex((prev) => (prev - 1 + length) % length);
  };

  const handleFarmerSelect = (farmer) => {
    const index = displayedFarmers.findIndex((f) => f.id === farmer.id);
    if (index >= 0) setCurrentSlideIndex(index);
  };
  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 1500); // ⏱️ adjust time (ms)

      return () => clearTimeout(timer);
    }
  }, [isLoading]);
  if (showLoader) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}
      >
        <DotLottieReact
          src="https://lottie.host/f8f55ce4-6a3c-4220-8585-4ffb195baa86/nCJAJ8wm36.lottie"
          loop
          autoplay
        />
      </div>
    );
  }
  return (
    <div className="">
      <div className="wrapper2">
        <h2 className="heading2">Meet Our Farmers</h2>
      </div>

      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {isLoading && "Loading farmers…"}
                {!isLoading && loadError && loadError}
                {!isLoading && !loadError && collectionDescription}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Farmers Slider */}
      {/* <div
        className="cw-slider-container"
        style={{ paddingTop: "7px", overflow: "hidden", position: "relative" }}
      >
        <div
          className="cw-slider"
          style={{
            display: "flex",
            transition: "transform 0.5s ease",
            transform: `translateX(-${currentSlideIndex * 100}%)`,
            width: "100%",
          }}
        >
          {displayedFarmers.map((farmer, farmerIdx) => (
            <div
              key={farmer.id || `farmer-slide-${farmerIdx}`}
              className="cw-container"
              style={{
                flex: "0 0 100%",
                maxWidth: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "250px",

              }}
            >
              <div className="cw-content">
                <div className="cw-details">
                  <h2>{farmer.name}</h2>
                  <p>
                    Registration No.: {normalize(farmer.registrationNo)} | DOB:{" "}
                    {normalize(farmer.dob)}
                  </p>
                </div>

                <div className="cw-tab-content">
                  <p className="max-w-56">
                    {getRandomBio(farmer.name) ||
                      "Learn more about our dedicated farmers."}
                  </p>
                </div>
              </div>
            </div>

          ))}
        </div>

    
        <div className="cw-nav-buttons">
          <button
            className="cw-nav-btn"
            onClick={goToPreviousSlide}
            aria-label="Previous farmer"
          >
            &#9665;
          </button>
          <button
            className="cw-nav-btn"
            onClick={goToNextSlide}
            aria-label="Next farmer"
          >
            &#9655;
          </button>
        </div>
      </div> */}

      <div
        className="cw-slider-container"
        style={{ paddingTop: "7px", position: "relative" }}
      >
        <div className="container">
          {displayedFarmers.map((farmer, farmerIdx) => (
            <div
              key={farmer.id || `farmer-${farmerIdx}`}
              className=" mb-3"
             
            >
              <div className="cw-content">
                <div className="cw-details">
                  <h4>{farmer.name}</h4>
                  <p>
                    Registration No.: {normalize(farmer.registrationNo)} | DOB:{" "}
                    {normalize(farmer.dob)}
                  </p>
                </div>

                <div className="cw-tab-content">
                  <p>
                    {getRandomBio(farmer.name) ||
                      "Learn more about our dedicated farmers."}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* Active Farmer's Cattle List */}
      <div className="bg-light mt-4">
        <div className="container p-3">
          <div className="underline2 my-3"></div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="m-0">{`${activeFarmer.name}'s Cattle`}</h5>
            <Link
              to={`/meet-our-cows-2?farmerId=${activeFarmer.id}`}
              className="btn p-0"
              style={{ color: "#333", fontSize: "15px" }}
            >
              View all
              <i
                className="icofont-rounded-right"
                style={{ color: "#4c922b" }}
              ></i>
            </Link>
          </div>

          <div className="position-relative">
            <div
              className="d-flex overflow-x-auto hide-scrollbar"
              style={{ gap: "12px", padding: "10px" }}
            >
              {(activeFarmer.cows || []).map((cow, cowIndex) => (
                <div
                  key={cow.id || `cow-${cowIndex}-${activeFarmer.id}`}
                  className="shop-item flex-shrink-0"
                  style={{ width: "90px" }}
                >
                  <div className="card bg-transparent border-0 text-center">
                    <img
                      src={cow.img}
                      alt={cow.name || "Cow"}
                      className="card-img-top mb-2"
                      style={{
                        width: "90px",
                        height: "80px",
                        borderRadius: "8px",
                        objectFit: "cover",
                      }}
                    />
                    <div className="card-body p-0">
                      <p className="card-title m-0">{cow.name}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* More Farmers */}
      {/* <div className="bg-light" style={{ marginTop: "-20px" }}>
        <div className="container p-3">
          <div className="underline2 my-3 mx-1"></div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="m-0">More Farmers</h5>
            <Link
              to="/meet-the-farmers-2"
              className="btn p-0"
              style={{ color: "#333", fontSize: "15px" }}
            >
              View all
              <i
                className="icofont-rounded-right"
                style={{ color: "#4c922b" }}
              ></i>
            </Link>
          </div>

          <div className="position-relative">
            <div
              className="d-flex overflow-x-auto hide-scrollbar"
              ref={moreFarmersScrollRef}
              style={{ gap: "12px", padding: "10px" }}
            >
              {[...displayedFarmers].map((farmer, farmerIndex) => (
                <div
                  key={farmer.id || `farmer-${farmerIndex}`}
                  className="shop-item flex-shrink-0"
                  style={{ width: "62px", cursor: "pointer" }}
                  onClick={() => handleFarmerSelect(farmer)}
                >
                  <div className="card bg-transparent border-0 text-center">
                   
                    <div className="card-body p-0">
                      <p className="card-title m-0">{farmer.name}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div> */}

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/meet-the-farmers-2"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          More Farmers
        </Link>
      </div>

      <div className="flex justify-between mt-20 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/meet-our-cows"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/sustanibilty-in-dairy-farm"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
      {/* <div className="bg-light" style={{ marginTop: "-20px" }}>
        <div className="container p-3">
          <div className="underline2 my-3 mx-1"></div>

          <h6 className="card-title fw-bold my-2 mx-1">Dairy Farm Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">
            <a href="meet-our-cows">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box1.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our
                      <br /> Cattle
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="meet-the-farmers">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box2.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our
                      <br /> Farmers
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="sustanibilty-in-dairy-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box3.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Sustainability in Dairy Farms
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="open-housing-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box4.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "12px" }}>
                      Learn About Open House Farming
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="farm-improvement-services">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box5.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Farm Improvement Services
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="smart-farming">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box6.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Smart Farming
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default MeetTheFarmers;
